import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { TypeaheadInput, TypeaheadInputParams } from 'portcall/typeahead/view';

export const BerthSelectorView = SuperCritical((props : TypeaheadInputParams) =>
    <div className="berth-selector">
        <TypeaheadInput {...props} />
    </div>
);


// WEBPACK FOOTER //
// ./apps/portcall/berthselector/view.tsx